import { createFileRoute } from '@tanstack/react-router';

import {
  WarehousesPage,
  validateWarehousesSearch,
} from '../../features/warehouses';

export const Route = createFileRoute('/_app/warehouses')({
  staticData: { crumbs: ['Склады'] },
  validateSearch: validateWarehousesSearch,
  component: WarehousesPage,
});
